import './css/style.css'

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { registerJobAndWait } from "../../slice";
import CheckDocxInterface from './components/CheckDocxInterface'
import FontSizeSelect from "./components/FontSizeSelect";
import PrefMunicipalitySelect from './components/PrefMunicipalitySelect';
import SettingInterfaceDocx from './components/SettingInterfaceDocx'
import WaitWidget from "./components/WaitWidget";
import alplat_logo from './img/alplat_logo.svg'
import bnr_ccca from './img/bnr_ccca.gif'
import bnr_env from './img/bnr_env.gif'
import eyecatch from './img/eyecatch_docx.png'
import logo from './img/logo-a2015.png'
import buildSettingDocx from "./lib/buildSettingDocx";

const DocxPage = (props) => {
  const [setting, setSetting] = useState(buildSettingDocx());
  const dispatch = useDispatch();

  const job = useSelector((state) => state.manual.job)
  const status = useSelector((state) => state.manual.status);
  const optional = useSelector((state) => state.manual.optional);

  const download = () => {

    if (!setting.pref) {
      alert('[STEP1] プルダウンにて「都道府県」を指定してください');
    } else {
      dispatch(registerJobAndWait(setting));
    }
  }

  return (
    <>
      <div id="header">
        <div id="logo-aplat">
          <a href="https://adaptation-platform.nies.go.jp/index.html"><img src={alplat_logo} alt="A-PLAT" /></a>
        </div>
        <div id="logo-nies">
          <a href="https://www.nies.go.jp/"><img src={logo} alt="nies" /></a>
        </div>
      </div>
      <div id="description" className="docx-bg">
        <div className="content">
          <h1>地域気候変動適応計画作成支援ツール</h1>

          <div className="grid-container">
            <div class="grid-left">
              <p>
                「地域気候変動適応計画作成支援ツール」は、令和５年３月改訂の地域気候変動適応計画策定マニュアルの関連ツールで、地域気候変動適応計画の策定に必要な気候に関する情報、気候変動影響予測データや、人口等の統計データの収集を支援するものです。
              </p>
              <p>
                ツールを実行することで、各地方公共団体に合わせたデータを、「ひな形編」のWORDファイルに自動で出力します。
              </p>
              <p>
                なお、データの利用に当たり、<a href="https://adaptation-platform.nies.go.jp/webgis/point.html">将来予測を利用される際の注意点</a>をご確認ください。
              </p>
            </div>
            <div class="grid-right">
              <img id="eyecatch" src={eyecatch} alt="eyecatch" />
            </div>
          </div>
        </div>
      </div>{/* description */}
      <div id="form">
        <div className="content">
          <div className="labelBox docx-bg">
            <div className="step">STEP1</div>
            <div className="order">都道府県・市区町村を選択してください。</div>
          </div>
          <div className="formItem">
            <PrefMunicipalitySelect setting={setting} setSetting={setSetting} />
          </div>

          <div className="labelBox docx-bg">
            <div className="box step">STEP2</div>
            <div className="box order">
              計画に含める指標を選択してください。
            </div>
          </div>
          <div className="formNote">
            <ul>
              <li>グラフ・画像は選択された自治体のものに差し変わります。</li>
              <li>チェックボックスにより、出力するデータをカスタマイズできます。</li>
            </ul>
          </div>

          <div className="formItem">
            <CheckDocxInterface setting={setting} setSetting={setSetting} /> 
            <SettingInterfaceDocx setting={setting} setSetting={setSetting} optional={optional} />
          </div>

          <div className="labelBox docx-bg">
            <div className="box step">STEP3</div>
            <div className="box order">
              グラフ画像のフォントの大きさを選択して下さい。
            </div>
          </div>
          <div className="formItem">
            <FontSizeSelect setting={setting} setSetting={setSetting} />
          </div>

          <div className="labelBox docx-bg">
            <div className="box step">STEP4</div>
            <div className="box order">
              上記で宜しければ、ダウンロードボタンを押してください。
            </div>
          </div>
          <div className="formItem">
            <form className="button" id="form">
              <button type="button" className="download-button" onClick={download}>ダウンロード</button>
            </form>
          </div>
        </div>
      </div>

      <div id="footer" >
        <div className="content">
          <div className="logos">
            <a href="http://ccca.nies.go.jp/ja/" target="_blank" rel="noreferrer"><img src={bnr_ccca} alt="国立環境研究所 気候変動適応センター" /></a>
            <a href="http://www.env.go.jp/" target="_blank" rel="noreferrer"><img src={bnr_env} alt="環境省" /></a>
          </div>
          <p className="version">version 1.3</p>
          <p className="browser">対応確認済みブラウザ: Google Chrome 139.0.7258.128, Firefox 141.0.3, Microsoft Edge 139.0.3405.86</p>
        </div>
      </div>

      <WaitWidget job={job} status={status} fileType="Word" />
    </>
  )
}

export default DocxPage;
